"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCenterBetweenPointerEvents = void 0;
const rc_js_util_1 = require("rc-js-util");
/**
 * In css pixels.
 */
function getCenterBetweenPointerEvents(firstEvent, secondEvent, result = new rc_js_util_1.Vec2.f32()) {
    firstEvent.pointerCssPosition
        .add(secondEvent.pointerCssPosition, result)
        .scalarMultiply(0.5, result);
    return result;
}
exports.getCenterBetweenPointerEvents = getCenterBetweenPointerEvents;
//# sourceMappingURL=get-center-between-pointer-events.js.map